import * as React from 'react';
import * as styles from './styles.css';

export interface IInlineButtonProps {
  onClick(): void;
}

export const InlineButton: React.FC<IInlineButtonProps> = ({ children, onClick }) => {
  return (
    <span className={styles['button']} onClick={onClick}>
      {children}
    </span>
  );
};

InlineButton.displayName = 'InlineButton';
